import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import { LoginEyeToggle, LoginInputRow, LoginLabel, LoginSubmit } from './LoginControls';
import { PasswordRuleList } from './PasswordRuleList';
import { PasswordRules } from '../../utils/passwordRules';

/** `/auth/action` — the new-password form behind a valid reset link. */
interface ResetPasswordStepProps {
  /** The account the link is for (a hidden username field for password managers). */
  email: string;
  password: string;
  setPassword: (value: string) => void;
  confirmPassword: string;
  setConfirmPassword: (value: string) => void;
  rules: PasswordRules;
  canSubmit: boolean;
  saving: boolean;
  onSubmit: (e: React.FormEvent) => void;
}

export const ResetPasswordStep: React.FC<ResetPasswordStepProps> = ({
  email,
  password,
  setPassword,
  confirmPassword,
  setConfirmPassword,
  rules,
  canSubmit,
  saving,
  onSubmit,
}) => {
  const [shown, setShown] = useState(false);
  const [confirmShown, setConfirmShown] = useState(false);
  return (
    <form onSubmit={onSubmit} className="flex flex-col">
      <input type="email" name="username" autoComplete="username" value={email} readOnly hidden />
      <LoginLabel htmlFor="reset-new-password">New password</LoginLabel>
      <LoginInputRow
        id="reset-new-password"
        icon={<Lock />}
        type={shown ? 'text' : 'password'}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="At least 8 characters"
        autoComplete="new-password"
        required
        autoFocus
        trailing={<LoginEyeToggle shown={shown} onToggle={() => setShown(!shown)} />}
        className="mb-[16px]"
      />
      <LoginLabel htmlFor="reset-confirm-password">Confirm password</LoginLabel>
      <LoginInputRow
        id="reset-confirm-password"
        icon={<Lock />}
        type={confirmShown ? 'text' : 'password'}
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        placeholder="Type it again"
        autoComplete="new-password"
        required
        trailing={<LoginEyeToggle shown={confirmShown} onToggle={() => setConfirmShown(!confirmShown)} />}
        className="mb-[14px]"
      />
      <PasswordRuleList rules={rules} />
      <LoginSubmit loading={saving} disabled={!canSubmit}>
        Update password
      </LoginSubmit>
    </form>
  );
};

export default ResetPasswordStep;
